import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1, delay, ease: [0.2, 0.8, 0.2, 1] }}
    >
      {children}
    </M>
  );
};

export const SectionHead = ({ index, label, title, children }) => (
  <div className="grid lg:grid-cols-12 gap-6 lg:gap-10 mb-14 lg:mb-20">
    <Reveal className="lg:col-span-4 flex items-center gap-4">
      <span className="font-mono text-xs text-gold">{index}</span>
      <span className="h-px w-10 bg-[#D4AF5A]/50" />
      <span className="label">{label}</span>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-8">
      <h2 className="font-display text-[2rem] sm:text-5xl lg:text-[3.6rem] font-semibold leading-[1.02] tracking-[-0.03em]">{title}</h2>
      {children && <p className="mt-6 max-w-xl text-[#A7A7AD] text-base leading-relaxed">{children}</p>}
    </Reveal>
  </div>
);
